import { Component, OnInit, Input } from '@angular/core';
import { Country, Region, CountryQuery, LoggingService, CountryService } from '@fgb/core';
import { FormGroup } from '@angular/forms';
import { firstValueFrom } from 'rxjs';

@Component({
  selector: 'fgb-country-and-regions-accounts',
  templateUrl: './country-and-regions-accounts.component.html',
  styleUrl: './country-and-regions-accounts.component.scss',
})
export class CountryAndRegionsAccountsComponent implements OnInit {
  @Input() Form: FormGroup;
  @Input() RegionLabel: string = 'Region';
  @Input() SeparateRow: boolean = false;
  countryOptions: Country[] = [];
  regionOptions: Region[] = [];
  selectedCountry: string;
  selectedCounty: string;

  constructor(private logService: LoggingService, private countryService: CountryService, private countryQuery: CountryQuery) {}

  async ngOnInit() {
    await firstValueFrom(this.countryService.fetchCountries());
    this.countryOptions = this.countryQuery.getAll().sort((a, b) => {
      if (a.Ordinal < b.Ordinal) {
        return -1;
      } else if (a.Ordinal === b.Ordinal) {
        return a.DisplayName.localeCompare(b.DisplayName);
      }
      return 0;
    });

    if (this.Form) {
      if (this.Form.get('Country')!.value) {
        this.selectedCountry = this.Form.get('Country')!.value;
        this.selectedCounty = this.Form.get('County')!.value;
        this.getRegionsByCountry(this.Form.get('Country')!.value);
      } else {
        this.Form.controls.Country.setValue(this.countryOptions[0]?.DisplayName);
        this.selectedCountry = this.countryOptions[0]?.DisplayName;
        this.getRegionsByCountry(this.selectedCountry);
      }
    }
  }

  getRegionsByCountry(CountryName: string): void {
    let foundCountry = this.countryOptions.find((c) => c.CountryName === CountryName);
    if (foundCountry) {
      this.getRegions(foundCountry);

      if (this.selectedCountry !== null) {
        if (this.selectedCountry === foundCountry.DisplayName) {
          this.Form.controls.County.setValue(this.selectedCounty);
        } else {
          this.Form.controls.County.setValue('');
        }
      } else {
        this.Form.controls.County.setValue('');
      }
    } else {
      this.Form.controls.Country.setValue('');
      this.logService.warning('No country data was found for that country');
    }
  }

  getRegions(country: Country): void {
    if (country.Regions) {
      this.regionOptions = [];
    }
    this.regionOptions = country.Regions;
  }
}
